import Backbone from 'backbone';
import { renderSections, getSectionInnerHTML } from '@/lib/renderSections';
import { PUB_SUB_EVENTS, subscribe, publish } from '@/lib/pubsub';
import OneMarketing from '@/modules/module-oneMarketing';
import OneTabSystem from '@/modules/module-oneTabSystem';
import OneSwiffySlider from '@/modules/module-oneSwiffySlider';

import 'slick-carousel';

const OneCartView = Backbone.View.extend({

    initialize: function (settings) {
        subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.handleCartUpdate.bind(this)
        );

        if (ORW.GWP && ORW.GWP.enable == `true`) {
            window.addEventListener("gwp_gift_added", this.handleCartUpdate.bind(this))
            window.addEventListener("gwp_gift_removed", this.handleCartUpdate.bind(this))
            window.addEventListener("gwp_gift_updated", this.handleCartUpdate.bind(this))
            window.addEventListener("gwp_gift_swap_updated", this.handleCartUpdate.bind(this))

            // Enable GWP UX/UI on cart page
            // Commented out to hide "Select a Free Gift" tab on cart page and drawer
            // document.querySelectorAll(`.system-gwp`).forEach((el) => {
            //     el.classList.remove(`hide`)
            // })
        }

        if (ORW.SP && ORW.SP.enable == `true`) {
            window.addEventListener("sp_added", this.handleCartUpdate.bind(this))
            window.addEventListener("sp_removed", this.handleCartUpdate.bind(this))
            window.addEventListener("sp_updated", this.handleCartUpdate.bind(this))
        }

        if (ORW.enableGTM) {
            ORW.marketing = ORW.marketing || new OneMarketing;
            ORW.marketing.initCartPageWatchers();
        }

        // this.fetchRecommendations(); 
        // Replaced with Nosto Recommendations
        // Init SwiffySlider
        OneSwiffySlider();

        this.accordionsAndTabs();

        this.tapeWeftsGWP();
        this.baseWeightGWP();
    },

    events: {
        'click .item-remove': 'handleRemoveItem',
        'change .item-quantity input': 'handleQuantityChange',
        'click .item-quantity button': 'handleQuantityButtonClick',
        'click .add-recommendation-btn': 'handleCrossSellButtonClick',
    },

    /**
     * Request updated cart HTML from Shopify Section Rendering API and replace the
     * current cart HTML with the new HTML
     */
    handleCartUpdate: async function () {
        const res = await renderSections(['cart']);

        if (res.cart.includes(`empty-cart-container`)) {
            // Updated cart is empty, inject the empty overlay
            const emtpyHTML = getSectionInnerHTML(res.cart, '.empty-cart-container');
            this.el.insertAdjacentHTML(
                'afterbegin',
                `<div class="empty-cart-container">${emtpyHTML}</div>`
            )
        } else {
            // Updated cart is not empty, remove the empty overlay
            this.el.querySelector('.empty-cart-container') && this.el.querySelector('.empty-cart-container').remove()
        }

        if (this.el.querySelector('.cart-items')) {
            const cartItemsHTML = getSectionInnerHTML(res.cart, '.cart-items');
            this.el.querySelector('.cart-items').innerHTML = cartItemsHTML;
        }

        if (this.el.querySelector('.total')) {
            const subtotalHTML = getSectionInnerHTML(res.cart, '.total');
            this.el.querySelector('.total').innerHTML = subtotalHTML;
        }

        if (this.el.querySelector('.cart-actions')) {
            const cartActionsHTML = getSectionInnerHTML(res.cart, '.cart-actions');
            this.el.querySelector('.cart-actions').innerHTML = cartActionsHTML;
        }

        if (document.querySelector('.cart-count')) {
            const countHtml = getSectionInnerHTML(res.cart, '.cart-count');
            document.querySelectorAll('.minicart-count').forEach(el => {
                el.innerHTML = countHtml;
            });

            document.querySelectorAll('.cart-count-desktop').forEach(el => {
                el.innerHTML = countHtml;
            });
        }

        // update cart progress bar
        if (document.querySelector('.tiered-progress-bar-container')) {
            const progressBarMsgHtml = getSectionInnerHTML(res.cart, '.progress-bar-msg');
            const progressBarPercent = getSectionInnerHTML(res.cart, '.tiered-progress-percentage');
            const progressBarBlocksHtml = getSectionInnerHTML(res.cart, '.progress-bar-blocks');
            document.querySelectorAll('.progress-bar-msg').forEach(el => {
                el.innerHTML = progressBarMsgHtml;
            });
            document.querySelectorAll('.tiered-progress-fill').forEach(el => {
                el.style.width = progressBarPercent;
            });
            document.querySelectorAll('.progress-bar-blocks').forEach(el => {
                el.innerHTML = progressBarBlocksHtml;
            });
        }

        if (this.el.querySelector('.free-shipping-progress-bar-cont')) {
            const cartProgressHTML = getSectionInnerHTML(res.cart, '.free-shipping-progress-bar-cont');
            this.el.querySelector('.free-shipping-progress-bar-cont').innerHTML = cartProgressHTML;
        }

        // Update nosto cart & recs
        if( window.Nosto ) { window.Nosto.reloadCart(); }
        if( getCartNostoRecs && typeof getCartNostoRecs == 'function') { setTimeout(getCartNostoRecs, 500); }

        // this.fetchRecommendations(); 
        // Replaced with Nosto Recommendations

        if (this.error) {
            const { id, message } = this.error;
            this.showError(id, message);
        }

        this.tapeWeftsGWP();
        this.baseWeightGWP();
    },

    /**
     * DD-2662: Tape wefts promo
     */
    tapeWeftsGWP: async function () {
        if (!ORW.GWP || ORW.GWP.tapeWeftsGwp.enable != 'true') {
            console.log('Tape Wefts GWP is disbaled!');
            return false;
        }

        if (sessionStorage.getItem('tapeWeftGwpAdded') && sessionStorage.getItem('tapeWeftGwpAdded') == 'true') {
            console.log('Tape wefts GWP already auto-added!!');
            return false;
        }

        console.log('Initiating Tape Wefts GWP!!');
        const tapeWefts = ORW.GWP.tapeWeftsGwp.tapeWeftIds
        let tapeWeftsAdded = false;
        let tapeGwpVariantId = 41482471931994;
        let tapeGwpKey = '';

        const cart = await fetch('/cart.json')
            .then(response => {
                if (!response.ok) { throw new Error('Network response was not ok.'); }
                return response.json();
            })
            .catch(error => { console.error('Error fetching cart:', error); });
        for (let item of cart.items) {
            if (tapeWefts.includes(item.product_id)) tapeWeftsAdded = true;
            if( item.properties.hasOwnProperty('_Tape_Weft_Gift')) {
                if( !sessionStorage.getItem('tapeWeftGwpAdded') ) sessionStorage.setItem('tapeWeftGwpAdded', 'true');
                tapeGwpKey = item.key;
            }
        }

        if (tapeWeftsAdded && tapeGwpKey.length == 0 ) {
            await fetch('/cart/add.js',
                {
                    method: 'POST', headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ items: [{ id: tapeGwpVariantId, quantity: 1, properties: { _Tape_Weft_Gift: 'Free Tape Roll' } }] })
                })
                .then(response => response.json())
                .then(cart => {
                    console.log('Tape wefts GWP added:', cart);
                    sessionStorage.setItem('tapeWeftGwpAdded', 'true');
                    publish(PUB_SUB_EVENTS.cartUpdate, {});
                })
                .catch(error => {
                    console.error('Error adding Tape wefts GWP:', error);
                });
        }

    },

    /**
     * DD-DD-2679: Base Weight GWP
     */
    baseWeightGWP: async function () {
        if (!ORW.GWP || ORW.GWP.baseWeightGWP != 'true') {
            console.log('Base Weight GWP is disbaled!');
            return false;
        }

        if (sessionStorage.getItem('baseWeightGwpAdded') && sessionStorage.getItem('baseWeightGwpAdded') == 'true') {
            console.log('Base Weight GWP already auto-added!');
            return false;
        }

        console.log('Initiating Base Weight GWP!');
        const preLoadeds = [6852866408538, 6852866343002, 6852866539610];
        let baseWeightAdded = false;
        let baseWeightVariantId = 40057293602906;
        let baseWeightKey = '';

        const cart = await fetch('/cart.json')
            .then(response => {
                if (!response.ok) { throw new Error('Network response was not ok.'); }
                return response.json();
            }).catch(error => { console.error('Error fetching cart:', error); });

        for (let item of cart.items) {
            if (preLoadeds.includes(item.product_id)) baseWeightAdded = true;
            if (item.variant_id == baseWeightVariantId) {
                if (!sessionStorage.getItem('baseWeightGwpAdded')) sessionStorage.setItem('baseWeightGwpAdded', 'true');
                baseWeightKey = item.key;
            }
        }

        if (baseWeightAdded && baseWeightKey.length == 0) {
            await fetch('/cart/add.js',
                {
                    method: 'POST', headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ items: [{ id: baseWeightVariantId, quantity: 1, properties: { GWP: 'Free Gift' } }] })
                })
                .then(response => response.json())
                .then(cart => {
                    sessionStorage.setItem('baseWeightGwpAdded', 'true');
                    console.log('Base Weight GWP added:', cart);
                    (0, s.mk)(s.n4.cartUpdate, {});
                })
                .catch(error => {
                    console.error('Error adding Base Weight GWP:', error);
                });
        }

    },

    /**
     * Fetches product recommendations based on the first item in the cart 
     * and updates the cross-sell container with the recommendations
     */
    fetchRecommendations: async function () {
        try {
            // select the first cart item element
            const cartItem = this.el.querySelector('.cart-item');
            if (!cartItem) return;

            const firstCartItemProductID = cartItem.dataset.productId;
            const crossSellContainers = document.querySelectorAll('.cross-sell-container');


            const url = new URL('/recommendations/products', window.location.origin);
            const params = new URLSearchParams({
                section_id: `global-recommendations`, // the ID of the section to render as cross-sell
                product_id: `${firstCartItemProductID}`,
                limit: 3, // number of related products to show
                intent: `related` //  'related' or 'complementary'
            });

            url.search = params.toString();

            const response = await fetch(url);
            const text = await response.text();

            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('section.product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
                crossSellContainers.forEach(container => {
                    container.innerHTML = recommendations.innerHTML;
                })
                window.ORW.lazyload && window.ORW.lazyload.update();
                this.initializeSlider();
            }
        } catch (e) {
            console.error(e);
        }
    },


    /**
     * Initializes the slick slider for the cross-sell product recommendations
     */
    initializeSlider: function () {
        const slider = this.el.querySelector('.global-product-recommendations')
        if (slider) {
            OneSwiffySlider(slider)
        }
    },

    /**
     * Handle click events on "remove item" buttons
     * @param {Event} e A click event
     */
    handleRemoveItem: async function (e) {
        e.preventDefault();
        const cartItemElem = e.currentTarget.closest('.cart-item');
        this.updateQuantity(cartItemElem.dataset.key, 0);
        if (ORW.enableGTM) {
            ORW.marketing.removeFromCartPage(e.currentTarget);
        }
    },

    /**
     * Start timer to send update request and reset timer if another change event
     * occurs before the timer is up
     * @param {Event} e A change event
     */
    handleQuantityChange: function (e) {
        if (this.timeout) clearTimeout(this.timeout)
        
        // Store the key and value before the timeout
        const key = e.currentTarget.dataset.key;
        const value = e.currentTarget.value;
        
        const onTimeout = _ => {
            if (ORW.enableGTM) {
                console.log('handleQuantityChange ORW.enableGTM');
                // Only call GTM tracking if the element still exists
                if (document.contains(e.currentTarget)) {
                    ORW.marketing.checkItemQtyChangeCartPage(e.currentTarget);
                }
            }
            this.updateQuantity(key, value);
        };
        this.timeout = setTimeout(onTimeout.bind(this), 1000);
    },

    /**
     * Request to update cart item quantity and update relevant info
     * @param {String} id The cart item's variant ID
     * @param {Number} quantity The cart item's new quantity
     */
    updateQuantity: async function (id, quantity) {
        this.setLoading(id);
        const res = await fetch(ORW.routes.cartChangeURL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: `application/json`
            },
            body: JSON.stringify({ id, quantity }),
        });
        publish(PUB_SUB_EVENTS.cartUpdate, {});
        const cart = await res.json();
        if (cart.errors) {
            this.error = {
                id,
                message: cart.errors.trim()
            };
        };
    },

    /**
     * Update the quantity input value based on the button clicked and dispatch a
     * change event
     * @param {Event} e A click event
     */
    handleQuantityButtonClick: function (e) {
        const input = e.currentTarget.closest('.item-quantity').querySelector('input');
        e.currentTarget.name === 'plus' ? input.stepUp() : input.stepDown();
        input.dispatchEvent(new Event('change', { bubbles: true }));
    },

    /**
     * Hide prices and show loading spinner for a cart item and the cart subtotal
     * @param {String} id The line item ID of the cart item
     */
    setLoading: function (id) {
        const subtotal = this.el.querySelector('.total-price');
        if (!subtotal) return; // Exit if element doesn't exist
        
        const subtotalSpan = subtotal.querySelector('span');
        const subtotalSpinner = subtotal.querySelector('.spinner');
        if (subtotalSpan) subtotalSpan.style.display = 'none';
        if (subtotalSpinner) subtotalSpinner.style.display = 'block';

        // Convert key to id if passed
        id = id.includes(`:`) ? id.split(`:`)[0] : id;

        const item = this.el.querySelector(`[data-id="${id}"]`);
        if (!item) return; // Exit if item doesn't exist
        
        const itemTotals = item.querySelectorAll('.item-total span');
        itemTotals.forEach(span => {
            span.style.display = 'none';
        });
        const itemSpinner = item.querySelector('.item-total .spinner');
        if (itemSpinner) itemSpinner.style.display = 'block';
    },

    /**
     * Add cross sell product to cart
     * @param {Event} e Click event
     */
    handleCrossSellButtonClick: async function (e) {
        e.preventDefault();

        const button = e.currentTarget;
        const productID = button.getAttribute('data-product-id');

        if (!productID) return;

        try {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    id: productID,
                    quantity: 1
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            if (button.getAttribute('data-ns-ref') || button.getAttribute('data-ns-reftype') && nostojs) {
                nostojs(api => {
                    api.recordAttribution({ 
                        type: "cp", 
                        target: button.getAttribute('data-ns-pid'),
                        ref: button.getAttribute('data-ns-ref'),
                        refType: button.getAttribute('data-ns-reftype'),
                    })
                    .done()
                });
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {});

        } catch (error) {
            console.error('Error adding product to cart:', error);
        }
    },

    showError: function (id, message) {
        const item = this.el.querySelector(`[data-id="${id}"]`);
        const error = item.querySelector('.item-error');
        console.log(error, message)
        error.textContent = message;
    },

    accordionsAndTabs: function () {
        var self = this;
        OneTabSystem.init({
            el: $(`.cart-extra-wrapper`)
        });
    },

    destroy: function () {
        this.unsubscribe();
    }
});

export default OneCartView;